import { Colis } from "@/interfaces/Return";
import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import Product from "../product/Product";
import { cn } from "@/lib/utils";
import { Package2 } from "lucide-react";

interface PackageProps {
  colis: Colis;
}

const Package: React.FC<PackageProps> = ({ colis }) => {
  return (
    <Accordion type="single" collapsible className={cn("w-full")}>
      <AccordionItem className="border rounded-lg mb-2" value="item">
        <AccordionTrigger
          className="hover:no-underline py-4 px-3 
              data-[state=open]:bg-muted/50 
              transition-colors duration-200
              hover:bg-muted/30 font-medium"
        >
          <div className="flex items-center gap-2">
            <Package2 className="w-6 h-6 mr-2" />
            <span> Colis N° {colis.colisCode}</span>
          </div>
        </AccordionTrigger>
        <AccordionContent className="px-3">
          {colis.articles.map((article) => (
            <Product product={article} />
          ))}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default Package;
